import { styled as t, css as o } from "styled-components";
import { q as r, a as s, n as i, d, o as h } from "./style-8UHgYe1v.js";
import { m as c, p as g } from "./index-QRkynDgW.js";
const y = t.div`
  margin: 0;
  padding: 0;
  ${c}
  ${g}
  color: inherit;

  ${({ $textAlign: e }) => e && o`
      text-align: ${e};
    `}

  ${({ $textEllipsis: e }) => {
  if (e)
    return typeof e == "number" ? r(e) : Object.entries(e).map(
      ([n, a]) => s(n, r(a))
    );
}}

  a {
    color: inherit;
    ${() => i.underline}

    /* Show "outline" when focused by keyboard only */
    [data-whatintent='keyboard'] &:focus-within {
      outline: 1px solid;
      ${d("outline-color", "dominant")};
    }
  }

  ${({ $variant: e }) => h(e)}
  ${({ $link: e, $variant: n }) => e && l(e, n)};
`, l = (e, n) => e === "underline" ? p.includes(n) ? o`
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      ` : i[e] : i[e], p = [
  "heading-xxl-sans",
  "heading-xl-sans",
  "heading-xl-serif",
  "heading-l-serif",
  "heading-m-serif",
  "heading-m-sans",
  "heading-s-sans",
  "heading-s-serif",
  "heading-xs-serif",
  "heading-xs-sans",
  "action",
  "action-l"
];
export {
  y as T
};
